import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../app.constants';
import { AssociateService } from '../shared/services/associate.service';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import {Location} from '@angular/common';
import { DownloadService } from '../../shared/services/html-png/html-png.service';


@Component({
  selector: 'app-mobile-profile-card',
  templateUrl: './mobile-profile-card.component.html',
  styleUrls: ['./mobile-profile-card.component.css']
})
export class MobileProfileCardComponent implements OnInit {
  public associate: any;
  public serverApiUrl: any;
  constructor(
            public associateService: AssociateService,
            public config: Configuration,
            public router: Router,
            public _location: Location,
            public route: ActivatedRoute,
            public htmlPng: DownloadService ) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    let tempObject = {};
    tempObject = JSON.parse(JSON.stringify( this.route.snapshot.data));
    this.associate = tempObject['associate']['data'][0];
  }

  backBtnClick() {
    this._location.back();
  }

  Share() {
    // this.htmlPng.downloadPng(`${this.associate.personalInformation.fullName}_BusinessCard`, 'businessCard');
    this.associateService.exportVcard(this.associate).subscribe(vCard => {
      this.htmlPng.downloadExcel(`${this.associate.personalInformation.fullName}.vcf`, 'text/x-vcard', vCard['vcardUrl'] );
    }, err => {});
  }


}
